/**
 * List of actions to control with permissions
 */
export enum ActionsEnum {
  autosave,
  editFieldKey,
  editQuestion,
  showQuestionBuilder,
  updateQuestion,
  fieldWrapper
}

/**
 * Interface of configurable items for actions
 */
export interface ActionsConfig {
  ord: number;
  description: string;
}

/**
 * Map of Action configuration
 */
 export const actionsConfigController = new Map<ActionsEnum, ActionsConfig>([
  // Actions
  [ ActionsEnum.autosave,              { ord: 1, description: "Is autosave Allowed for currently connected user" } ],
  [ ActionsEnum.editFieldKey,          { ord: 2, description: "Can currently connected user edit a field key" } ],
  [ ActionsEnum.editQuestion,          { ord: 3, description: "Can currently connected user edit a question" } ],
  [ ActionsEnum.showQuestionBuilder,   { ord: 4, description: "Can currently connected user edit a question" } ],
  [ ActionsEnum.updateQuestion,        { ord: 5, description: "Can currently connected user update a question" } ],
  [ ActionsEnum.fieldWrapper,           { ord: 6, description: "Can form wrapper access to allow" } ]
]);
